import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";
import { commonIconProps32 } from "@/utils/constants";
import { formatTestId } from "@/utils/formatTestId";

import { CustomCardHeader } from "../CardHeader";
import { CustomPageTitle } from "../CardTitle";

interface HeaderWithBackProps {
  linkProps: React.ComponentProps<typeof Link>;
  title: string;
  children?: React.ReactNode;
  headerClass?: string;
}

export const HeaderWithBack = ({
  linkProps,
  title,
  children,
  headerClass,
}: HeaderWithBackProps) => {
  return (
    <CustomCardHeader
      classes={cn(
        "flex-row justify-between flex-col md:flex-row gap-4 sm:gap-3",
        headerClass
      )}
    >
      <Link
        {...linkProps}
        className={cn("flex items-center gap-4", linkProps.className)}
        data-testid={`${formatTestId(title)}-back-link`}
      >
        <ArrowLeft {...commonIconProps32} />
        <CustomPageTitle>{title}</CustomPageTitle>
      </Link>
      {children}
    </CustomCardHeader>
  );
};
